

/**
 * Параметры фильтрации мероприятий
 */

import { arrayToObject, objectToArray } from "../../../shared/shared";

export interface OrganizersCalendarForm {


    /**
     * Количество записей в выборке
     * @default 16
     */
    limit?: number;

    /**
     * Смещение относительно первого элемента
     * @default 0
     */
    offset?: number;

    /**
     * Приём заявок
     */
    is_recruiting?: Record<string, boolean>;

    /**
     * команды, в которых состоит пользователь (появятся в будущем)
     */
      my?: boolean;

}

export class OrganizersCalendarDTO {

    /**
     * Количество записей в выборке
     * @default 16
     */
    limit?: string;

    /**
     * Смещение относительно первого элемента
     * @default 0
     */
    offset?: string;

    /**
     * Глобальные типы мероприятия (обновляются динамически)
     */
    is_recruiting?: string[];

    /**
     * команды, в которых состоит пользователь (появятся в будущем)
     */
      my?: boolean;

    [key: string]: string | number | Date | string[] | boolean | undefined;
}

export function convertToOrganizersForm(dto: OrganizersCalendarDTO): OrganizersCalendarForm {
    return {
        limit: Number(dto.limit),
        offset: Number(dto.offset),
        is_recruiting: arrayToObject(dto.is_recruiting),
        my: dto.my
    };
}

export function convertToOrganizersCalendarDTO(form: OrganizersCalendarForm): OrganizersCalendarDTO {

    return {
        limit: form.limit?.toString(),
        offset: form.offset?.toString(),
        is_recruiting: objectToArray(form.is_recruiting),
        my: form.my
    };
}

export function convertUrlParamsToOrganizersCalendarDTO(params: URLSearchParams): OrganizersCalendarForm {
    return {
        is_recruiting: arrayToObject(params.getAll('is_recruiting').length ? params.getAll('is_recruiting') : undefined),
        my: params.get('my') === 'true' ? true : params.get('my') === 'false' ? false : undefined
    };
}